import { SafePromise } from '@benzinga/safe-await';

import { RestfulClient } from '@benzinga/session';
import { QuoteAnalysisResponse } from '../entities';
import { Session } from '@benzinga/session';
import { QuotesEnvironment } from '../environment';

export class QuoteAnalysisRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(QuotesEnvironment).analysisUrl, session, { 'x-device-key': true });
  }

  getQuoteAnalysis = async (symbol: string): SafePromise<QuoteAnalysisResponse> => {
    const url = this.URL(`api/quote/${symbol}/analysis`);

    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
